import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class FireExtinguishingSystemsDto extends InspectionCase {
  equipmentAccordingSpec?: InspectionCase;
  equipmentMeetPlans?: InspectionCase;
  distancesBetweenSprayersAccordingSpec?: InspectionCase;
  sprinklersInstalledAsNeeded?: InspectionCase;
  sprinklersInterruptionExist?: InspectionCase;
  sprnklersOnDrySystemsAccordingSpec?: InspectionCase;
}

export class FireExtinguishingSystems extends FireExtinguishingSystemsDto {
  constructor(
    data: FireExtinguishingSystemsDto = {
      title: 'מערכות כיבוי באמצעות מתזים / נחירים / אביזרי קצה'
    }
  ) {
    super(data);
    this.equipmentAccordingSpec = new InspectionCase({
      ...data.equipmentAccordingSpec,
      title: `תיאור המתזים/ נחירים/ אזיזרי קצה: (סוג ,K מקדם , תבריג , טמפ' הפעלה) תואם לתוכניות שאושרו ותנאי הסביבה`
    });
    this.equipmentMeetPlans = new InspectionCase({
      ...data.equipmentMeetPlans,
      title: `המתזים/ נחירים/ אביזרי קצה מתאימים (listed) לסוג המערכת ובהתאם לתוכניות שאושרו`
    });
    this.distancesBetweenSprayersAccordingSpec = new InspectionCase({
      ...data.distancesBetweenSprayersAccordingSpec,
      title: `המרחקים בין המתזים/ נחירים , בהתאם לתכניות המאושרות ודרישות התקן/ יצרן המתזים/ נחירים`
    });
    this.sprinklersInstalledAsNeeded = new InspectionCase({
      ...data.sprinklersInstalledAsNeeded,
      title: `במידת הצורך הותקנו מתזים בחלל תקרת תותב`
    });
    this.sprinklersInterruptionExist = new InspectionCase({
      ...data.sprinklersInterruptionExist,
      title: `האם ישנם הפרעות לפיזור ל- המתזים`
    });
    this.sprnklersOnDrySystemsAccordingSpec = new InspectionCase({
      ...data.sprnklersOnDrySystemsAccordingSpec,
      title: `במערכות יבשות אופן התקנת המתזים יהיו, בהתאם לדרישות התקן (מתזים תלויים עם return bend)`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.equipmentAccordingSpec.isApplicable ||
        this.equipmentAccordingSpec.isPassed) &&
        (!this.equipmentMeetPlans.isApplicable ||
          this.equipmentMeetPlans.isPassed) &&
        (!this.distancesBetweenSprayersAccordingSpec.isApplicable ||
          this.distancesBetweenSprayersAccordingSpec.isPassed) &&
        (!this.sprinklersInstalledAsNeeded.isApplicable ||
          this.sprinklersInstalledAsNeeded.isPassed) &&
        (!this.sprinklersInterruptionExist.isApplicable ||
          this.sprinklersInterruptionExist.isPassed) &&
        (!this.sprnklersOnDrySystemsAccordingSpec.isApplicable ||
          this.sprnklersOnDrySystemsAccordingSpec.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.equipmentAccordingSpec.getNotes(),
      ...this.equipmentMeetPlans.getNotes(),
      ...this.distancesBetweenSprayersAccordingSpec.getNotes(),
      ...this.sprinklersInstalledAsNeeded.getNotes(),
      ...this.sprinklersInterruptionExist.getNotes(),
      ...this.sprnklersOnDrySystemsAccordingSpec.getNotes()
    ];
  }
}
